import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrl, IrisBaseCRUDService } from '@iris/api-query';
import { IrisLanguageI } from '../../models/IrisLanguage';
import { map, tap } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { IrisQueryParams } from '@iris/api-query';
import { IrisGlobalSettingsService, IrisModuleAliasType } from '@iris/common/services/settings/global-settings.service';

@Injectable({ providedIn: 'root' })
@ApiUrl('/system/i18n/languages')
export class IrisLanguageService extends IrisBaseCRUDService<IrisLanguageI> {
  private readonly globalSettingsService = inject(IrisGlobalSettingsService);

  private languages: IrisLanguageI[] = [];

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  }

  getAll(params?: IrisQueryParams): Observable<IrisLanguageI[]> {
    return super.getAll(params).pipe(
      tap(languages => {
        this.languages = languages;
      }),
    );
  }

  getLanguagesNames(languages: string[]): string[] {
    if (!this.languages) {
      return languages;
    }

    return languages.map((languageName) => this.languages.find(_lang => _lang.name === languageName)?.title || languageName);
  }

  getSystemLanguages(): Observable<IrisLanguageI[]> {
    return forkJoin([
      this.globalSettingsService.getGlobalSettingsById$<{ preferredLanguages: string[] }>(IrisModuleAliasType.Translations),
      this.getAll(),
    ]).pipe(
      map(([translationsSettings, allLanguages]) => {
        return allLanguages
          .filter(l =>  translationsSettings.value.preferredLanguages.includes(l.name))
          .sort((a, b) => a.name.localeCompare(b.name));
      }),
    );
  }
}
